<div class="messages-container show-chat full-height">
  <!-- Interface unique de chat avec l'IA -->
  <div class="chat-content">
    <div class="chat-header">
      <div class="header-content">
        <button class="back-button" (click)="goBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <img [src]="niagaraAIImage" alt="Niaga IA" class="profile-image">
        <div class="user-info">
          <span class="user-name">Niaga IA</span>
          <small class="user-status">Assistant IA en ligne</small>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="chatMenu" class="chat-options">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #chatMenu="matMenu">
          <button mat-menu-item (click)="clearConversation()">
            <mat-icon>refresh</mat-icon>
            <span>Nouvelle conversation</span>
          </button>
          <button mat-menu-item>
            <mat-icon>help</mat-icon>
            <span>Aide</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="contenu" #messageContainer (scroll)="onScroll($event)">
      <div class="welcome-message" *ngIf="messages.length === 0">
        <div class="ai-avatar">
          <img [src]="niagaraAIImage" alt="Niaga IA">
        </div>
        <h3>Bonjour ! Je suis Niaga IA</h3>
        <p>Votre assistant intelligent pour vous aider avec toutes vos questions. Comment puis-je vous aider aujourd'hui ?</p>
        
        <div class="suggested-prompts">
          <button class="prompt-suggestion" (click)="sendSuggestedMessage('Comment puis-je améliorer mes publications ?')">
            Comment améliorer mes publications ?
          </button>
          <button class="prompt-suggestion" (click)="sendSuggestedMessage('Quelles sont les meilleures pratiques pour Lenali ?')">
            Meilleures pratiques pour Lenali
          </button>
          <button class="prompt-suggestion" (click)="sendSuggestedMessage('Aide-moi à rédiger un post intéressant')">
            Aide pour rédiger un post
          </button>
        </div>
      </div>

      <div *ngFor="let message of messages" class="message-row">
        <div [ngClass]="{'sent': message.isUser, 'received': !message.isUser, 'ai-message': !message.isUser}" class="message-content">
          <div class="message-avatar" *ngIf="!message.isUser">
            <img [src]="niagaraAIImage" alt="Niaga IA">
          </div>
          
          <div class="message-text-container">
            <!-- Lecteur audio pour les messages audio -->
            <div *ngIf="message.audioUrl && message.audioUrl !== '' && message.audioUrl !== 'null' && !isAudioError(message.id)" class="audio-message">
              <div class="audio-player-simple">
                <button class="play-button-simple" (click)="playAudioById(message.id)">
                  <mat-icon>{{ getAudioElementById(message.id)?.paused !== false ? 'play_arrow' : 'pause' }}</mat-icon>
                </button>
                
                <div class="audio-progress-container">
                  <div class="audio-time-info">
                    <span class="current-time">{{ formatTime(getCurrentProgress(getAudioElementById(message.id))) }}</span>
                    <span class="separator">/</span>
                    <span class="total-time">{{ formatTime(getMaxDuration(getAudioElementById(message.id))) }}</span>
                  </div>
                  
                  <input type="range" 
                         class="audio-progress-bar" 
                         [value]="getCurrentProgress(getAudioElementById(message.id))"
                         [max]="getMaxDuration(getAudioElementById(message.id))"
                         (input)="updateAudioTime($event, getAudioElementById(message.id))">
                </div>
                
                <!-- Élément audio caché -->
                <audio [id]="'audio-' + message.id"
                       [src]="message.audioUrl" 
                       preload="none"
                       *ngIf="!is3GPPFormat(message.audioUrl)"
                       (loadedmetadata)="onAudioLoaded($event)"
                       (timeupdate)="onTimeUpdate($event)" 
                       (error)="onAudioError($event, message.id)"
                       (canplay)="onAudioCanPlay($event)"
                       style="display: none;">
                </audio>
                
                <!-- Élément video caché pour 3GPP -->
                <video [id]="'video-' + message.id"
                       [src]="message.audioUrl" 
                       preload="none"
                       *ngIf="is3GPPFormat(message.audioUrl)"
                       (loadedmetadata)="onAudioLoaded($event)"
                       (timeupdate)="onTimeUpdate($event)" 
                       (error)="onAudioError($event, message.id)"
                       (canplay)="onAudioCanPlay($event)"
                       style="display: none;">
                </video>
              </div>
            </div>

            <!-- Fallback pour erreur audio -->
            <div *ngIf="message.audioUrl && message.audioUrl !== '' && message.audioUrl !== 'null' && isAudioError(message.id)" class="audio-error">
              <mat-icon>mic_off</mat-icon>
              <span>Message vocal (erreur de lecture)</span>
            </div>

            <p *ngIf="message.text" class="message-text" [innerHTML]="formatMessage(message.text)"></p>
            <div class="typing-indicator" *ngIf="message.isTyping">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          
          <small class="message-time">{{ getFormattedTime(message.timestamp) }}</small>
        </div>
      </div>

      <!-- Indicateur de frappe -->
      <div class="message-row" *ngIf="isAITyping">
        <div class="received ai-message message-content">
          <div class="message-avatar">
            <img [src]="niagaraAIImage" alt="Niaga IA">
          </div>
          <div class="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>

    <div class="chat-input">
      <!-- Champ de texte normal (quand pas d'enregistrement) -->
      <div class="message-input-container" *ngIf="!isRecordingAudio && !recordedAudioBlob">
        <textarea #messageInput 
                 class="textarea" 
                 placeholder="Message" 
                 [(ngModel)]="currentMessage"
                 (input)="adjustTextareaHeight($event)" 
                 (keydown)="onKeydown($event)"
                 [disabled]="isLoading"
                 rows="1" 
                 wrap="soft">
        </textarea>
      </div>

      <!-- Progression d'enregistrement -->
      <div class="recording-progress-container" *ngIf="isRecordingAudio">
        <div class="recording-indicator">
          <div class="recording-dot"></div>
          <span class="recording-text">Enregistrement en cours...</span>
          <span class="recording-duration">{{ recordingDurationText }}</span>
        </div>
      </div>

      <!-- Prévisualisation audio enregistré -->
      <div class="audio-preview-container" *ngIf="recordedAudioBlob && !isRecordingAudio">
        <div class="audio-preview-player">
          <button class="preview-play-button" (click)="togglePreviewPlayback()">
            <mat-icon>{{ isPreviewPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
          </button>
          
          <div class="preview-waveform-container">
            <div class="preview-duration">{{ previewDurationText }}</div>
            <div class="preview-waveform">
              <div class="preview-wave-bar" *ngFor="let bar of previewWaveformBars" 
                   [style.height.px]="bar"></div>
            </div>
          </div>
          
          <button class="preview-delete-button" (click)="deleteRecordedAudio()">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <button mat-icon-button 
              class="send-button"
              [class.active]="currentMessage.trim() || isRecordingAudio || recordedAudioBlob"
              [class.recording]="isRecordingAudio"
              [class.preview]="recordedAudioBlob && !isRecordingAudio"
              [disabled]="isLoading"
              (click)="handleButtonClick()">
        
        <!-- Icône microphone par défaut -->
        <mat-icon *ngIf="!currentMessage.trim() && !isRecordingAudio && !recordedAudioBlob && !isLoading" 
                  class="material-icons">mic</mat-icon>
        
        <!-- Icône stop pendant l'enregistrement -->
        <mat-icon *ngIf="isRecordingAudio && !isLoading" 
                  class="material-icons">stop</mat-icon>
        
        <!-- Icône envoi quand il y a du texte -->
        <mat-icon *ngIf="currentMessage.trim() && !isLoading" 
                  class="material-icons">send</mat-icon>
        
        <!-- Icône envoi pour l'audio prévisualisé -->
        <mat-icon *ngIf="recordedAudioBlob && !isRecordingAudio && !isLoading" 
                  class="material-icons">send</mat-icon>
        
        <!-- Spinner pendant le chargement -->
        <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
      </button>
    </div>
  </div>
</div>
